import React from 'react';
import { NavLink } from 'react-router-dom';

import dashboardIcon  from "../../assets/images/icons/dashboard_100dp_FFC107_FILL0_wght400_GRAD0_opsz48.png";
import applicationsIcon  from "../../assets/images/icons/demography_100dp_FFC107_FILL0_wght400_GRAD0_opsz48.png";
import usersIcon  from "../../assets/images/icons/yellow_groups_icon.png";
import quotesIcon  from "../../assets/images/icons/request_quote_100dp_FFC107_FILL0_wght400_GRAD0_opsz48.png";


import "../../styles/DashboardStyles/DashboardNav.css";



export default function DashboardNav() {
    return (
        <div className="dashboardNav">
            <aside>
                <NavLink to="/dashboard/Home">
                <img src={dashboardIcon} alt="Dashboard" />
                <p>Dashboard</p></NavLink>

                <NavLink to="/dashboard/Applications">
                <img src={applicationsIcon} alt="Applications" />
                <p>Applications</p></NavLink>

                <NavLink to="/dashboard/Users">
                <img src={usersIcon} alt="Users" />
                <p>Users</p></NavLink>

                <NavLink to="/dashboard/Quotes">
                <img src={quotesIcon} alt="Quotes" />
                <p>Quotes</p></NavLink>

                {/*<NavLink to="/dashboard/Settings">
                <img src={settingsIcon} alt="Settings" />
                <p>Settings</p></NavLink>*/}

            </aside>
        </div>
    );
}